/**
 * Used on "vestigingen"
 */

import React from "react"
import ReactDOM from "react-dom"
import { Loader } from "google-maps"

import Vestigingen from "./location/Vestigingen"

const loader = new Loader("AIzaSyBzq4Ixboz3rLpxFuYL3Dia1OtbPtruQg0")

loader.load().then(async (google) => {
    window.google = google
    ReactDOM.render(
        React.createElement(Vestigingen),
        document.querySelector("#vestigingen_root")
    )
})
